import { getHours, getYear, getMonth, getDate, getTime } from "date-fns";
import { DespatchTask } from "Models/despatch.task";
import { Event } from "react-big-calendar";

import { CalendarEvent } from "../components/DiaryCalendar";
import { getCompleteDateRange } from "./startDate";

export const getDiaryEventsFromDespatchTasks = (tasks?: DespatchTask[]) => {
  if (!tasks) return [];

  const eventTaskList: CalendarEvent[] = [];

  for (const task of tasks) {
    const { startTime, endTime } = getCompleteDateRange({
      startDate: task.startDate,
      endDate: task.endDate,
      considerEvening: true,
    });

    const start = task.startDate && startTime ? startTime : undefined;
    const end = endTime;

    eventTaskList.push({
      title: `${task.type}`,
      start,
      end,
      resource: {
        task: {
          ...task,
        },
        order: task.job,
      },
    });
  }

  return eventTaskList;
};

interface HourGroup {
  [key: string]: CalendarEvent[];
}

export const groupTasksByHour = (eventTaskList?: CalendarEvent[]) => {
  if (!eventTaskList) return [];

  const groups = eventTaskList.reduce((groups, event) => {
    const dateHour = event.start ? getHours(event.start) : 0;
    const dateDay = event.start ? getDate(event.start) : 0;
    const dateMonth = event.start ? getMonth(event.start) : 0;
    const dateYear = event.start ? getYear(event.start) : 0;

    const key = `${dateYear}-${dateMonth}-${dateDay}-${dateHour}`;

    if (!groups[key]) {
      groups[key] = [];
    }
    groups[key].push(event);

    return groups;
  }, {} as HourGroup);

  const groupedEvents: CalendarEvent[] = [];

  Object.entries(groups).map(([eventKey, value]) => {
    const dateKeys: any = eventKey.split("-");
    const firstEvent = value.at(0);

    return groupedEvents.push({
      start: firstEvent?.start ?? new Date(dateKeys[0], dateKeys[1], dateKeys[2], dateKeys[3], 0),
      end: firstEvent?.end ?? new Date(dateKeys[0], dateKeys[1], dateKeys[2], dateKeys[3], 60),
      resource: {
        group: groups[eventKey].length > 1,
        tasks: groups[eventKey],
      },
    });
  });

  return groupedEvents;
};

export const orderByDate = (events: Event[]) => {
  return events.sort((a: Event, b: Event) => {
    if (!a.start || !b.start) return 0;

    return getTime(a.start) - getTime(b.start);
  });
};

export const getTasksDiaryEvents = (tasks: DespatchTask[]): CalendarEvent[] => {
  if (!tasks) return [];

  const eventTaskList: CalendarEvent[] = [];

  for (const task of tasks) {
    if (task && task.id) {
      eventTaskList.push({
        title: `${task.type}`,
        start: task.startDate ? new Date(task.startDate) : undefined,
        end: task.startDate ? new Date(task.startDate) : undefined,
        resource: {
          task: {
            ...task,
            job: task.job,
          },
          order: task.job,
        },
      });
    }
  }

  return eventTaskList;
};
